<script>
  import { afterUpdate } from 'svelte';
  import Icon from './Icon.svelte';

  export let data = {};
  export let scale = () => 0;

  let meloniChartData = [];
  let schleinChartData = [];

  afterUpdate(() => {
    meloniChartData = [{
      w: scale(data.meloni.percent.positive),
      sentiment: 'positive',
      val: new Intl.NumberFormat('it-IT', { style: 'percent' }).format(data.meloni.percent.positive),
      v: data.meloni.percent.positive,
    },{
      w: scale(data.meloni.percent.negative),
      sentiment: 'negative',
      val: new Intl.NumberFormat('it-IT', { style: 'percent' }).format(data.meloni.percent.negative),
      v: data.meloni.percent.negative,
    },{
      w: scale(data.meloni.percent.neutral),
      sentiment: 'neutral',
      val: new Intl.NumberFormat('it-IT', { style: 'percent' }).format(data.meloni.percent.neutral),
      v: data.meloni.percent.neutral,
    }].sort((a, b) => b.v - a.v);
    schleinChartData = [{
      w: scale(data.schlein.percent.positive),
      sentiment: 'positive',
      val: new Intl.NumberFormat('it-IT', { style: 'percent' }).format(data.schlein.percent.positive),
      v: data.schlein.percent.positive,
    },{
      w: scale(data.schlein.percent.negative),
      sentiment: 'negative',
      val: new Intl.NumberFormat('it-IT', { style: 'percent' }).format(data.schlein.percent.negative),
      v: data.schlein.percent.negative,
    },{
      w: scale(data.schlein.percent.neutral),
      sentiment: 'neutral',
      val: new Intl.NumberFormat('it-IT', { style: 'percent' }).format(data.schlein.percent.neutral),
      v: data.schlein.percent.neutral,
    }].sort((a, b) => b.v - a.v);
	});
</script>

<div class="icons">
  <div class="icons--meloni">      
    {#each meloniChartData as m, index}
      <div
        class="icons--icon icon-{index} {m.v === 0 ? 'zero' : ''}"
        style="width: {m.w}px; height: {m.w}px">
        <Icon sentiment={m.sentiment} src="meloni" />
        <div class="value {m.sentiment}">{m.val}</div>
      </div>
    {/each}
  </div>
  <div class="icons--schlein">
    {#each schleinChartData as s, index}
      <div
        class="icons--icon icon-{index} {s.v === 0 ? 'zero' : ''}"
        style="width: {s.w}px; height: {s.w}px">
        <Icon sentiment={s.sentiment} src="schlein" />
        <div class="value {s.sentiment}">{s.val}</div>
      </div>
    {/each}
  </div>
</div>

<style>
  .icons {
    display: flex;
    flex-direction: column;
    height: 50vh;
    justify-content: space-between;
    width: 100%;
  }

  .icons--meloni,
  .icons--schlein {
    flex: 1 1 auto;
    position: relative;
  }

  .icons--icon {
    display: block;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
  }

  .icons--icon.icon-0 {
    z-index: 3;
  }

  .icons--icon.icon-1 {
    left: 20%;
    z-index: 2;
  }

  .icons--icon.icon-2 {
    left: 80%;
    z-index: 1;
  }

  .icons--icon .value {
    color: var(--neutral);
    font-family: 'Fira Mono', monospace;
    font-weight: 500;
    left: 50%;
    position: absolute;
    text-align: center;
    top: 100%;
    transform: translate3d(-50%, 0, 0);
  }

  .icons--icon .value.positive {
    color: var(--positive);
  }

  .icons--icon .value.negative {
    color: var(--negative);
  }

  @media screen and (min-width: 1024px) {
    .icons {
      flex-direction: row;
      flex-wrap: wrap;
      height: auto;
    }

    .icons--meloni,
    .icons--schlein {
      flex: 0 0 45%;
      height: 280px;
    }
  }

</style>